import dayjs from 'dayjs';
import DATE_FORMAT from '../constants/dateConstants';
import { setDatesAction } from '../ducks/requestDuck';
import { setPartialDatesAction } from '../ducks/filtersDuck';
import { getIsPartialRoomStay, getPartialDates } from '../selectors/filtersSelectors';

const clearInvalidPartialDatesThunk = (dates) => async (dispatch, getState) => {
  dispatch(setDatesAction(dates));

  if (getIsPartialRoomStay(getState())) {
    const dayjsStartDate = dayjs(dates.startDate, DATE_FORMAT);
    const dayjsEndDate = dayjs(dates.endDate, DATE_FORMAT);
    const partialDates = getPartialDates(getState());
    if (dayjsStartDate.isAfter(dayjs(partialDates.startDate, DATE_FORMAT))
      || dayjsEndDate.isBefore(dayjs(partialDates.endDate, DATE_FORMAT))) {
      dispatch(setPartialDatesAction({ startDate: null, endDate: null }));
    }
  }
};

export default clearInvalidPartialDatesThunk;
